import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { Icon } from 'antd';
import {
  Container,
  TemplateConatiner,
  EmptySettingsDetails,
  LoaderContainer,
  TemplateWrapper,
} from './styles';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import Loader from '../../components/Loader';
import CreateComplexMailTemplateModal from '../../components/CreateNewTemplate/CreateComplexMailTemplateModal';
import DeleteTemplateModal from '../../components/Modals/DeleteTemplateModal';
import LockStatusCheckModal from '../../components/Modals/LockStatusCheckModal';
import { getTemplateStatus } from '../../utils/services/templatesAPI';

// app store context API
import { AppStoreContext } from '../../context/appStoreContext';
import { EMAIL_TEMPLATES_LIST } from './translationValues';
import { useTranslation } from 'react-i18next';
import EmailTemplate from './emailTemplate';
import { CREATE_NEW_TEMPLATE_MODAL } from '../../components/CreateNewTemplate/translationValues';
import UpgradePlanModal from '../../components/Modals/UpgradePlanModal';
import { fetchPlanUsageDetails } from '../../utils/services/planUsage';
import { SUPPORT_EMAIL_ID, checkSessionUserAccess, ENTERPRISE_ENV } from '../../utils/helper';
import { useSessionContext } from '../../context/sessionContext';

const NAMESPACES = ['EMAIL_TEMPLATES_LIST'];

const EmailTemplateSection = props => {
  const { mailCategoryList, templatesList, fetchingCategories, totalTemplates, languageList } = props;
  const { t } = useTranslation(NAMESPACES);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [updateModalVisibility, setUpdateModalVisibility] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const { loginVisible, setLoginVisible } = useContext(AppStoreContext);
  const [lockedBy, setLockedBy] = useState({});
  const history = useHistory();

  const [documentLimit, setDocumentLimit] = useState(null);
  const [planName, setPlanName] = useState('');
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const sessionSelector = useCallback(store => store.userData, []);
  const [userDetails] = useSessionContext(sessionSelector);

  useEffect(() => {
    if (
      loginVisible === false &&
      Boolean(selectedTemplate) &&
      Boolean(selectedTemplate.id) &&
      !Boolean(selectedAction)
    ) {
      history.push(`/complexEmailDesign/${selectedTemplate.id}`);
    }
  }, [loginVisible, selectedTemplate, selectedAction, history]);

  const enableModalVisibility = async (actionType, template) => {

    if(ENTERPRISE_ENV || checkSessionUserAccess(userDetails, 'master') || actionType === "delete-mail-template") {
      setUpdateModalVisibility(true);
      setSelectedAction(actionType);
      setSelectedTemplate(template);
      return;
    }
    try {    
      const response = await fetchPlanUsageDetails();
      if(response?.statusCode === 1918) {
        const { templateLimit: created } = response.data.usage;
        const { templateLimit: limit, planName } = response.data.upperLimit;
        console.log({limit:limit})
        console.log({created:created})
        if (created >= limit) {
          setDocumentLimit(limit);
          setPlanName(planName);
          setShowUpgradeModal(true);
        } else {
          setUpdateModalVisibility(true);
          setSelectedAction(actionType);
          setSelectedTemplate(template);
        }
      }
    }
    catch(e) {
      console.error(e);
    }
  };

  const disableModalVisibility = () => {
    setUpdateModalVisibility(false);
    setSelectedAction(null);
    setSelectedTemplate(null);
  };

  const redirectToMailTemplate = template => {
    if (template.id) {
      history.push(`/complexEmailDesign/${template.id}`);
    } else if (template.templateId) {
      history.push(`/complexEmailDesign/${template.templateId}`);
    }
  };

  const onSuccessMailDeletion = async () => {
    setUpdateModalVisibility(false);
    props.deteteTemplate(true);
  };

  const renderBody = (categoriesTemp, templatesList) => {
    return (
      <React.Fragment>
        {templatesList.length > 0 && (
          <>
            <TemplateWrapper>
              {templatesList.map(templateObj => {
                return (
                  <EmailTemplate
                    key={templateObj.id}
                    templateObj={templateObj}
                    categoriesTemp={categoriesTemp}
                    redirectToTemplate={redirectToMailTemplate}
                    enableModalVisibility={enableModalVisibility}
                    languageList={languageList}
                  />
                );
              })}
            </TemplateWrapper>
          </>
        )}
      </React.Fragment>
    );
  };

  return (
    <>
      <Container>
        {fetchingCategories ? (
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        ) : (
          <TemplateConatiner>
            <>{totalTemplates === 0 ? '' : renderBody(mailCategoryList, templatesList)}</>
            {!fetchingCategories &&
              updateModalVisibility &&
              !loginVisible &&
              selectedAction &&
              (selectedAction === 'create-email-template' ? (
                <CreateComplexMailTemplateModal
                  visible={updateModalVisibility}
                  onCancel={disableModalVisibility}
                  onSucess={redirectToMailTemplate}
                  categoryType="template"
                />
              ) : (
                ''
              ))}
            {!fetchingCategories &&
              updateModalVisibility &&
              !loginVisible &&
              selectedAction &&
              (selectedAction === 'delete-mail-template' ? (
                <DeleteTemplateModal
                  visible={updateModalVisibility}
                  onCancel={disableModalVisibility}
                  targetTemplate={selectedTemplate}
                  categoryType="template"
                  onSucess={onSuccessMailDeletion}
                  isMailTemplate={true}
                  complexEmailTemplate={true}
                />
              ) : (
                ''
              ))}
            {!fetchingCategories &&
              updateModalVisibility &&
              !loginVisible &&
              selectedAction &&
              selectedAction === 'template-locked' && (
                <LockStatusCheckModal
                  visible={updateModalVisibility}
                  lockedBy={lockedBy}
                  onCancel={disableModalVisibility}
                />
              )}
            {templatesList.length !== 0 && (
              <>                
                {templatesList.length !== totalTemplates ? (
                  <div className="addMore">
                    <Icon type="loading" />
                    {t(
                      EMAIL_TEMPLATES_LIST.LOADING_MORE.key,
                      EMAIL_TEMPLATES_LIST.LOADING_MORE.value,
                    )}
                  </div>
                ) : (
                  <div className="allData">
                    {t(
                      EMAIL_TEMPLATES_LIST.GOT_ALL_TEMPLATES_LIST.key,
                      EMAIL_TEMPLATES_LIST.GOT_ALL_TEMPLATES_LIST.value,
                    )}
                  </div>
                )}
              </>
            )}
          </TemplateConatiner>
        )}
        {!fetchingCategories && templatesList.length === 0 && (
          <EmptySettingsDetails>
            <div className="empty-illustration">
              <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
            </div>
            <div className="empty-txt" style={{ color: 'black' }}>
              <span>
                {t(
                  EMAIL_TEMPLATES_LIST.EMPTY_TEMPLATES_LIST.key,
                  EMAIL_TEMPLATES_LIST.EMPTY_TEMPLATES_LIST.value,
                )}
              </span>
              <span
                className="empty-links"
                onClick={() => enableModalVisibility('create-email-template', null)}
              >
                {t(
                  EMAIL_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_ACTION.key,
                  EMAIL_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_ACTION.value,
                )}
              </span>
              <span>
                {t(
                  EMAIL_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_INFO.key,
                  EMAIL_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_INFO.value,
                )}
              </span>
            </div>
          </EmptySettingsDetails>
        )}
        <UpgradePlanModal
          visible={showUpgradeModal}
          modalText={
            planName === 'Premium' ?
              t(CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.key, CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.value, { emailId: SUPPORT_EMAIL_ID })
              : planName === 'Free' ? t(CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.value, { documentLimit })
                : t(CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.value, { documentLimit })
          }
          onCancel={() => setShowUpgradeModal(false)}
        />
      </Container>
    </>
  );
};

export default EmailTemplateSection;
